import React from 'react'

const BlockedRestaurants = () => {
  return (
    <div>
      
    </div>
  )
}

export default BlockedRestaurants
